// extracted by mini-css-extract-plugin
export default {"sandshoresWrapper":"GTASandshore_sandshoresWrapper__juC6f"};